import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
    root: {
        position: 'relative',

        '&:not(:hover) $hoverOverlay': {
            opacity: 0,
        },
    },
    image: {
        width: 48,
        height: 48,
    },
    hoverOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,

        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',

        backgroundColor: '#0008',
        color: '#fff',
        opacity: 1,
        transition: theme.transitions.create('opacity'),
    },
}));